import { Character } from '../components/CharacterSelection';

/**
 * Lista de personagens disponíveis para seleção no jogo
 */
export const availableCharacters: Character[] = [
  // {
  //   id: 'tiabel_victory',
  //   name: 'tIA Bel Vitória',
  //   imagePath: '/assets/sprites/tiabel_victory/tiabel_victory_BD_128/frame_0001.png'
  // },
  // {
  //   id: 'negra',
  //   name: 'Negra',
  //   imagePath: '/negra_grande.png'
  // },
  // {
  //   id: 'tiabel',
  //   name: 'tIA Bel',
  //   imagePath: '/assets/sprites/tiabel/tiabel_BD_128/frame_0001.png'
  // },
  {
    id: 'maria',
    name: 'Maria',
    imagePath: '/assets/sprites/maria/Maria_2.png'
  },
  {
    id: 'caio',
    name: 'Caio',
    imagePath: '/assets/sprites/caio/Caio_1.png'
  },
  {
    id: 'thiago',
    name: 'Thiago',
    imagePath: '/assets/sprites/thiago/Thiago_2.png'
  },
  {
    id: 'joao',
    name: 'João',
    imagePath: '/assets/sprites/joao/Joao_1.png'
  },
  {
    id: 'julia',
    name: 'Júlia',
    imagePath: '/assets/sprites/julia/Julia_2.png'
  },
  {
    id: 'larissa',
    name: 'Larissa',
    imagePath: '/assets/sprites/larissa/Larissa_1.png'
  }
]; 